import { render, staticRenderFns } from "./MergeEntitiesModal.vue?vue&type=template&id=5038fba9"
import script from "./MergeEntitiesModal.vue?vue&type=script&lang=js"
export * from "./MergeEntitiesModal.vue?vue&type=script&lang=js"
import style0 from "./MergeEntitiesModal.vue?vue&type=style&index=0&id=5038fba9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports